<article class="dashboard-container" *ngIf="!loading; else loaderBlock">

  <!----- START OF HEAD SECTION ------>
  <section class="header-section">
    <app-progress-tree></app-progress-tree>
  </section>
  <!------ END OF HEAD SECTION ------->

  <!----- START OF Filter SECTION ------>
  <section class="filter-section">
    <div class="filter-section_right">
      <div class="backButton" (click)="onBackClickHandler()">
        <img src="/assets/images/back.svg"/>
      </div>
      <label>{{ clientName }}</label>
      <div class="split-section">
      </div>
      <div class="more-metrices">
        <img src="/assets/images/more.svg"/>
        <label>More metrices</label>
      </div>
    </div>
    <div class="filter-section_left">
      <img src="/assets/images/calendar.svg"/>
      <button class="btn-transparent">Filter <img src="/assets/images/filter.svg"/></button>
    </div>
  </section>
  <!----- END OF Filter SECTION ------>

  <!----- START OF CONTENT SECTION ------>
  <section class="content-section">
    <div class="content-section__left">

      <!----- START OF KEY METRICS SECTION ------>
      <section class="key-metrics">
        <label>Key Metrics</label>
        <div class="key-metrics-content">
          <ng-container *ngIf="!showMetricLoader else loaderBlock">
            <div class="carousel-container">
              <owl-carousel-o #owlRef [options]="carouselOptions"
                              (dragging)="onCarouselSlideDragging($event)">
                <ng-container *ngFor="let metric of metrics">
                  <ng-template carouselSlide>
                    <div class="slide-item" [ngClass]="{ selected: metric.label === selectedMetric?.label }"
                         (click)="!isCarouselSlideDragging && onCarouselSlideItemClick(metric)">
                      <h3>{{ metric.label }} </h3>
                    </div>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>
              <div class="action-container">
                <div class="prev" (click)="owlRef.prev()"></div>
                <div class="next" (click)="owlRef.next()"></div>
              </div>
            </div>
            <div class="chart-container">
              <ng-container *ngIf="!showMetricChartLoader else chartLoaderBlock">
                <app-line-projection-chart *ngIf="selectedMetric.label !== 'Revenue&Margin'"
                                           [chartData]="chartData" [lineLabelName]="$any(selectedMetric?.label)">
                </app-line-projection-chart>
                <app-revenue-margin-chart *ngIf="selectedMetric.label === 'Revenue&Margin'"
                                          [chartData]="chartData">
                </app-revenue-margin-chart>
              </ng-container>
              <ng-template #chartLoaderBlock>
                <div class="chart-loader">
                  <app-loader></app-loader>
                </div>
              </ng-template>
            </div>
          </ng-container>
        </div>
      </section>
      <!----- END OF KEY METRICS SECTION ------>

      <section class="two-layout" *ngIf="persona !== 'GCSP'">
        <section class="initiatives">
          <label>Innovation and Productivity Initiatives</label>
          <div class="initiative-list">
            <div class="initiative-header">
              <div
                class="menu"
                *ngFor="let tab of initiativesTabs"
                [ngClass]="{ active: tab?.active }"
                (click)="tabClickHandler(tab?.name)"
              >
                <img [src]="tab?.active ? tab?.activeIcon : tab?.inActiveIcon" />
                <label> {{ tab?.name }} ({{tab.count}})</label>
              </div>
            </div>
            <div class="list">
              <app-innovation-productivity
                *ngFor="let initiative of initiativesData"
                [initiativeData]="initiative"
                [type]="activeInitiativeType"
              ></app-innovation-productivity>
              <ng-container *ngIf="!initiativesData.length"><p class="no-data">No Data Found</p></ng-container>
            </div>
            <!-- <div class="initiative-footer">
              <div class="view-all">View All</div>
            </div> -->
          </div>
        </section>
        <section class="meetings">
          <label>Governance Meetings</label>
          <div class="meeting-list">
            <div class="upcoming">
              <label>Upcoming</label>
              <ng-container *ngFor="let meeting of upcomingMeetings">
                <app-meetings
                  [meeting]="meeting"
                  [type]="'upcoming'"
                ></app-meetings>
              </ng-container>
            </div>
            <div class="past">
              <label>Past</label>
              <ng-container *ngFor="let meeting of pastMeetings | slice:0:3">
                <app-meetings [meeting]="meeting" [type]="'past'"></app-meetings>
              </ng-container>
            </div>
            <!-- <div class="meeting-footer">
              <div class="view-all">View All</div>
            </div> -->
            <ng-container *ngIf="!meetingLoading; else loaderBlock"> </ng-container>
          </div>
        </section>
    </section>

      <section *ngIf="persona === 'GCSP'">
        <label>Talent Management</label>
        <app-team-utilization class="talent-mgmt"></app-team-utilization>
        <!-- <div class="engagement-summary">
                          <app-risk-management></app-risk-management>
                          <div class="engagement-footer">
                            <div class="view-all">View All</div>
                          </div>
                        </div> -->
      </section>

      <section *ngIf="persona === 'GCSP'">
        <label>Risk Management</label>
        <app-risk-management></app-risk-management>
      </section>
    </div>
    <div class="content-section__right">
      <section>
        <label>Key Highlights</label>
        <div class="key-highlights">
          <app-key-highlights></app-key-highlights>
        </div>
      </section>
      <section class="meetings" *ngIf="persona === 'GCSP'">
        <label>Governance Meetings</label>
        <div class="expand">
          <img src="/assets/images/open.svg" alt="Expand"/>
        </div>
        <div class="meeting-list">
          <div class="upcoming">
            <label>Upcoming</label>
            <ng-container *ngFor="let meeting of upcomingMeetings">
              <app-meetings [meeting]="meeting" [type]="'upcoming'"></app-meetings>
            </ng-container>
          </div>
          <div class="past">
            <label>Past</label>
            <ng-container *ngFor="let meeting of pastMeetings">
              <app-meetings [meeting]="meeting" [type]="'past'"></app-meetings>
            </ng-container>
          </div>
          <ng-container *ngIf="!meetingLoading; else loaderBlock"></ng-container>
        </div>
      </section>
      <section class="initiatives" *ngIf="persona === 'GCSP'">
        <label>Innovation and Productivity Initiatives</label>
        <div class="initiative-list">
          <div class="initiative-header">
            <div class="menu" *ngFor="let tab of initiativesTabs" [ngClass]="{ active: tab?.active }"
                 (click)="tabClickHandler(tab?.name)">
              <img [src]="tab?.active ? tab?.activeIcon : tab?.inActiveIcon"/>
              <label> {{ tab?.name }} ({{ tab.count }})</label>
            </div>
          </div>
          <div class="list">
            <app-innovation-productivity *ngFor="let initiative of initiativesData" [initiativeData]="initiative"
                                         [type]="activeInitiativeType"></app-innovation-productivity>
            <ng-container *ngIf="!initiativesData.length">
              <p class="no-data">No Data Found</p>
            </ng-container>
          </div>
          <div class="initiative-footer">
            <!-- <div class="view-all">View All</div> -->
          </div>
        </div>
      </section>
      <section class="testimonials" *ngIf="persona === 'GCSP'">
        <label>Testimonials</label>
        <div class="testimonial-list">
          <app-testimonial></app-testimonial>
        </div>
      </section>
      <section class="quick-links" *ngIf="persona === 'GCSP'">
        <label>Quick links</label>
        <div class="links">
          <app-quick-link *ngFor="let link of quickLinks" [link]="link"></app-quick-link>
        </div>
      </section>
    </div>
  </section>
  <!----- END OF CONTENT SECTION ------>
</article>
<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
